import AxiosInstance from "../config/AxiosInstance";

const getListTransactions = async (page: string, limit: number, searchAmount: string, searchLocation: string, searchNo: string, searchUser: string, sort: string, locationId: string, companyId: string, searchTable = '') => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/transactions/find-all-transaction`, {
            params: {
                page: page,
                limit: limit,
                searchAmount: searchAmount,
                searchLocation: searchLocation,
                locationId: locationId,
                companyId: companyId,
                searchNo: searchNo,
                searchUser: searchUser,
                searchTable: searchTable,
                sort: sort,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}


const getListUser = async (companyId: any, page: any, limit: any,) => {
    try {
        const { data } = await AxiosInstance.get('/api/companies/listUserForCompany/' + companyId + '/' + page + '/' + limit);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getDetailTansactions = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/transactions/find-one-transaction` + `/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListTransactionMonth = async (page: string, limit: number,) => {
    try {
        const { data } = await AxiosInstance.get(`/api/finex/transaction-month/find-all-with-location`, {
            params: {
                page: page,
                limit: limit,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const changeLockTransaction = async (id: string, payload: { locked: boolean }) => {
    try {
        const { data } = await AxiosInstance.put('/api/finex/transaction-month/change-lock/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

export {
    getListTransactions,
    getDetailTansactions,
    getListTransactionMonth,
    changeLockTransaction,
    getListUser
}